import React from 'react'
import { useTranslation } from 'next-i18next'
import { Box, IconBolt, Text } from '@machobear/design-system'
import { format, parseISO } from 'date-fns'

type Props = {
  deal: {
    description: string
    start_date: string
    end_date: string
    hide_expiry: boolean
  }
}

const SpecialOffer = ({ deal }: Props) => {
  const { t } = useTranslation()

  return (
    <Box
      display="flex"
      gap="xxsmall"
      borderRadius="large"
      padding="small"
      background="promoteLight"
      boxShadow="borderPromoteLight"
    >
      <Box>
        <IconBolt tone="promote" />
      </Box>
      <Box display="flex" flexDirection="column" gap="small">
        <Text tone="promote" weight="strong">
          {t('Special Offer')}
        </Text>
        <Text tone="promote" size="small">
          {deal.description}
        </Text>
        {!deal.hide_expiry && (
          <Text tone="promote" size="xsmall">
            {t('Expires on')} {format(parseISO(deal.end_date), 'MMM d, yyyy')}.
          </Text>
        )}
      </Box>
    </Box>
  )
}

export default SpecialOffer
